"use strict";

import Vue from 'vue';
import axios from "axios";
import Qs from 'qs';
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
  baseURL: process.env.NODE_ENV == "production" ? process.env.VUE_APP_BASE_URL : process.env.VUE_APP_BASE_URL,
  timeout: 60 * 1000, // Timeout
  // withCredentials: false, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers['Authorization'] = `Bearer ${localStorage.getItem("token")}`
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    if (typeof config.data == 'object') {
      config.data.token = localStorage.getItem("token")
    }
    if (typeof config.data !== 'undefined') {
      if (config.method === 'post' && config.data.constructor !== FormData) {
        //如果是图片则不转string
        config.data = Qs.stringify(config.data);
      }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.status == 200 && response.data.status == 200) {
      return response.data.data ? response.data.data : response.data;
    }
    if (response.status == 200 && response.data.status == 20000) {
      return response.data.result
    }
    return Promise.reject(response);
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
